<ng-container *ngIf="moreTowns && moreTowns.length > 0 && moreTownText">
    <p class="more-towns-title">
        {{ moreTownText }}
        <a (click)="resetScroll()" class="town-for-more"
            *ngFor="let town of moreTowns; trackBy: trackByName; let last = last;"
            [routerLink]="routerLinkToPreparat + '/' + searchTarget + '/' + town.nameEn">
            {{ town.name }}
            <span style="padding-right: 5px;" *ngIf="!last">,</span>
        </a>
        <span>.</span>
    </p>
</ng-container>